import { render, staticRenderFns } from "./TemperaturePresetsMenu.vue?vue&type=template&id=99cc4442&"
import script from "./TemperaturePresetsMenu.vue?vue&type=script&lang=ts&"
export * from "./TemperaturePresetsMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports